export function updateCourseState(courseState, newCourseState) {
    const passedChanged = hasPassedChanged(courseState, newCourseState);
    const failedChanged = hasFailedChanged(courseState, newCourseState);
    const completedChanged = hasCompletedChanged(courseState, newCourseState);
    const scoreChanged = hasScoreChanged(courseState, newCourseState);
    return {
        value: {
            passed: passedChanged ? true : courseState.passed,
            failed: failedChanged ? true : courseState.failed,
            completed: completedChanged ? true : courseState.completed,
            score: scoreChanged ? Math.max(Number(courseState.score), Number(newCourseState.score)) : courseState.score
        },
        changed: {
            passed: passedChanged,
            failed: failedChanged,
            completed: completedChanged,
            score: scoreChanged,
            someValue: passedChanged || failedChanged || completedChanged || scoreChanged
        }
    };
}
function hasPassedChanged(courseState, newCourseState) {
    return !courseState.passed && newCourseState.passed;
}
function hasFailedChanged(courseState, newCourseState) {
    if (courseState.passed || newCourseState.passed) {
        return false;
    }
    return !courseState.failed && newCourseState.failed;
}
function hasCompletedChanged(courseState, newCourseState) {
    return !courseState.completed && newCourseState.completed;
}
function hasScoreChanged(courseState, newCourseState) {
    return courseState.score !== newCourseState.score;
}
